import { Component, OnInit, EventEmitter, Input, Output } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslocoService } from '@ngneat/transloco';
import { OkAloneService } from 'src/app/ok-alone.service';

@Component({
  selector: 'app-worker-escalation',
  templateUrl: './worker-escalation.component.html',
  styleUrls: ['./worker-escalation.component.scss']
})
export class WorkerEscalationComponent implements OnInit {

  @Input() worker:any;

  escalation:any = null;
  edit_view:string = '';
  editing = false;

  constructor(private router: Router, private route: ActivatedRoute, public okService: OkAloneService, private transloco: TranslocoService) { }

  ngOnInit(): void {

    //console.log(this.worker);

    this.getEscalation();


  }

  getEscalation(){

    this.okService.get("escalation/worker/"+this.worker.id,[])
    .subscribe((data) => {

      this.escalation = data.body;

      //console.log(this.escalation);
    })
  }

  chooseEdit(view:string){
    //console.log(view);
    this.editing = true;
    this.edit_view = view;

  }


  onCompleted(completed: any) {

    //console.log(completed);
    this.editing = false;
    if(completed){
      this.getEscalation();
      this.okService.setAlert(this.transloco.translate("Your escalation procedure has been updated"),"success");
    }
  }

  deleteEscalation(){
    if(confirm(this.transloco.translate("Are you sure you want to delete the worker escalation?"))) {


      this.okService.put('escalation/worker/'+this.worker.id,{'text':''})
      .subscribe((data) => {

        this.getEscalation();

        this.okService.setAlert(this.transloco.translate("The worker escalation procedure has been removed"),"success");

      });


    }
  }
}
